import { render, staticRenderFns } from "./StudentSocialProject.vue?vue&type=template&id=13a00b7a&"
import script from "./StudentSocialProject.js?vue&type=script&lang=js&"
export * from "./StudentSocialProject.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports